export const Bio = {
  name: "Ronit Jena",
  roles: ["Full Stack Developer", "UI/UX Designer", "Programmer"],
  description:
    "I am Passionate and versatile creator with a love for storytelling. Adept at translating ideas into compelling content through writing, design, and multimedia.I am Dedicated to crafting impactful narratives that resonate.",
  github: "https://github.com/ronitjena09",
  resume:
    "https://drive.google.com/file/d/1CeJFhl2R2y3OShIPJyCo5bSc9Jsv9wCj/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/ronitjena",
  twitter: "https://twitter.com/rxnittt/",
  insta: "https://www.instagram.com/rxnitt/",
  facebook:
    "https://www.facebook.com/profile.php?id=100071524353340&mibextid=ZbWKwL",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "PostgreSQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/6910f0503efdd315c8f9b858234310c06e04d9c0/icons/postgresql/postgresql-plain.svg",
      },
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/6910f0503efdd315c8f9b858234310c06e04d9c0/icons/git/git-plain.svg",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
    ],
  },
];

export const experiences = [{}];

export const education = [
  {
    id: 0,
    img: "https://upload.wikimedia.org/wikipedia/en/6/6f/Nist.berhampur.logo.jpg",
    school: "	National Institute of Science and Technology, Brahmapur",
    date: "Oct 2020 - May 2024",
    grade: "7.41 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Information Technology at National Institute of Science and Technology, Brahmapur. I have completed 7 semesters and have a CGPA of 7.41. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. ",
    degree: "Bachelor of Technology - BTech, Information Technology",
  },
  {
    id: 1,
    img: "https://d2q79iu7y748jz.cloudfront.net/s/_squarelogo/256x256/b0ec704a3bd57a66d2ce0c98e1d35e1a",
    school: "Narayana Junior College, Madhapur",
    date: "Apr 2017 - Apr 2019",
    grade: "67.3%",
    desc: "I completed my class 12 high school education at Narayana Junior College, Madhapur, where I studied Science.",
    degree: "Narayana Junior College, Madhapur,TSBIE(XII), Science",
  },
  {
    id: 2,
    img: "https://d3bat55ebwjhsf.cloudfront.net/schools/logos/user_generic_school_user/adfc98dd-7d61-4b4b-a00a-f2499f346d93-3a61efe2-4b_C4votlu.webp",
    school: "Stewart School, Bhubaneswar",
    date: "Apr 2007 - Feb 2017",
    grade: "71.3%",
    desc: "I completed my class 10 education at Stewart School, Bhubaneswar, where I studied Science with Computer Application.",
    degree: "ICSC(X), Science with Computer",
  },
];

export const projects = [
  {
    id: 9,
    title: "Steganography",
    date: "Jun 2023 - July 2023",
    description:
      "Steganography is the art of concealing information within seemingly innocuous data, such as images or audio files, to evade detection. By subtly embedding data, like text or images, into the carrier medium, steganography ensures covert communication, making the hidden content imperceptible to unintended observers.",
    image:
      "https://keystrokes2016.files.wordpress.com/2016/08/steganography04072015.jpg",
    tags: [
      "argparse",
      "Wave",
      "opencv",
      "numpy",
      "Pillow",
      "pytest-shutil",
      "subprocess.run",
      "stegano",
      "Python3",
    ],
    category: "machine learning",
    github: "https://github.com/ronitjena09/Steganography/",
    member: [
      {
        name: "Ronit Jena",
        img: "https://avatars.githubusercontent.com/u/98580165?s=400&u=bf85ede665674b964c8b3482ef3a67f03a247c68&v=4",
        linkedin: "https://www.linkedin.com/in/ronitjena/",
        github: "https://github.com/ronitjena09/",
      },
    ],
  },
  {
    id: 0,
    title: "Scientific-Computing-with-Python",
    date: "Aug 2023 - Sept 2023",
    description:
      "Scientific Computing with Python from FreeCodeCamp is a comprehensive course introducing Python for scientific applications. Covering essential libraries like NumPy and Matplotlib, it equips learners with skills for data analysis, visualization, and mathematical computations, fostering proficiency in Python's role within scientific computing and research.",
    image:
      "https://res.cloudinary.com/dyd911kmh/image/upload/f_auto,q_auto:best/v1510052208/The_argument_for_Scientific_Python_fpgvhk.png",
    tags: ["Programming", "Python3", "freeCodeCamp"],
    category: "programming",
    github: "https://github.com/ronitjena09/Scientific-Computing-with-Python",
    member: [
      {
        name: "Ronit Jena",
        img: "https://avatars.githubusercontent.com/u/98580165?s=400&u=bf85ede665674b964c8b3482ef3a67f03a247c68&v=4",
        linkedin: "www.linkedin.com/in/ronitjena",
        github: "https://github.com/ronitjena09",
      },
    ],
  },
  {
    id: 0,
    title: "LeetHub",
    date: "Aug 2023 - Present",
    description:
      "Progressed through 150+ LeetCode problems in Java and Python, sharpening my algorithmic thinking and coding expertise.",
    image:
      "https://assets.leetcode.com/static_assets/public/images/LeetCode_Sharing.png",
    tags: ["Programming", "Python", "LeetCode", "Java"],
    category: "programming",
    // github: "https://github.com/ronitjena09/Scientific-Computing-with-Python",
    member: [
      {
        name: "Ronit Jena",
        img: "https://avatars.githubusercontent.com/u/98580165?s=400&u=bf85ede665674b964c8b3482ef3a67f03a247c68&v=4",
        linkedin: "www.linkedin.com/in/ronitjena",
        github: "https://github.com/ronitjena09",
      },
    ],
  },
  {
    id: 0,
    title: "HackerHub",
    date: "Aug 2023 - Present",
    description:
      "Versatile developer with HackerRank Gold in Java & SQL, 4-star Python, and certifications demonstrating web development and software engineering foundations.",
    image:
      "https://gdm-catalog-fmapi-prod.imgix.net/ProductLogo/8b9fc1fa-bb42-45c6-957b-3b6611c542f1.png?ixlib=react-9.0.3&ch=Width%2CDPR&auto=format&w=4088",
    tags: ["Programming", "Python", "HackerRank", "Java", "SQL"],
    category: "programming",
    // github: "https://github.com/ronitjena09/Scientific-Computing-with-Python",
    member: [
      {
        name: "Ronit Jena",
        img: "https://avatars.githubusercontent.com/u/98580165?s=400&u=bf85ede665674b964c8b3482ef3a67f03a247c68&v=4",
        linkedin: "www.linkedin.com/in/ronitjena",
        github: "https://github.com/ronitjena09",
      },
    ],
  },

  {
    id: 1,
    title: "Social Media Management PowerHouse",
    date: "Sept 2023 - Jan 2024",
    description:
      " Built an all-in-one social media powerhouse à la Zoho, empowering brands to thrive online during a full-stack development internship at NIST(Autonomous). Leveraged diverse technologies including:Next.js, beautifully designed with Tailwind CSS, Express.js, Material UI, .NET, Graph.js, TensorFlow, DJango, MongoDB and GraphQL.",
    image:
      "https://th.bing.com/th/id/OIP.dmcH17LcqwEoONJD8vM-_wHaDt?rs=1&pid=ImgDetMain",
    tags: [
      "Next.js",
      "Tailwind CSS",
      "Node.JS",
      "Tensorflow",
      "MongoDB",
      ".NET",
      "Django",
      "Graph.js",
    ],
    category: "web app",
    github: "https://github.com/ronitjena09/Social-Site-Handler",
    member: [
      {
        name: "Ronit Jena",
        img: "https://avatars.githubusercontent.com/u/98580165?s=400&u=bf85ede665674b964c8b3482ef3a67f03a247c68&v=4",
        linkedin: "https://www.linkedin.com/in/ronitjena/",
        github: "https://github.com/ronitjena09/",
      },
    ],
  },

  {
    id: 8,
    title: "Real Time Object Recognition using YOLO v5",
    date: "August 2023",
    description:
      "Real-time Object Recognition with YOLO v5 leverages the YOLO (You Only Look Once) algorithm to swiftly detect and classify objects in images or video frames. Its efficiency arises from a single, comprehensive pass through the neural network, making it suitable for dynamic applications like surveillance and autonomous vehicles.",
    image:
      "https://miro.medium.com/v2/resize:fit:640/format:webp/1*Ic-ME4SgJeIgRDZvZu0ivw.jpeg",
    tags: ["YOLO v5", "COCO ", "PyTorch", "OpenCV", "NumPy", "Matplotlib "],
    category: "machine learning",
    github:
      "https://github.com/ronitjena09/Real-Time-Object-Detection-With-OpenCV",
    webapp: "",
    member: [
      {
        name: "Ronit Jena",
        img: "https://avatars.githubusercontent.com/u/98580165?s=400&u=bf85ede665674b964c8b3482ef3a67f03a247c68&v=4",
        linkedin: "https://www.linkedin.com/in/ronitjena/",
        github: "https://github.com/ronitjena09/",
      },
    ],
  },
  {
    id: 9,
    title: "AI SaaS Platform",
    date: "December 2023-Present",
    description:
      "Built a Real Software-as-a-Service app with AI features and payments credits system. Used Various technologies, such as Next.js 14, Clerk, MongoDB, Cloudinary AI, and Stripe.",
    image:
      "https://uploads-ssl.webflow.com/61ec28b09861e7548b546b8e/6436a5ada887c87f90d8798d_ai-tools-for-saas.jpg",
    tags: [
      "Next.js 14",
      "Node.js ",
      "Tailwind CSS",
      ".NET",
      "Express.js",
      "Python",
      "Restful APIs",
      "Material UI",
    ],
    category: "web app",
    github: "https://github.com/ronitjena09/ai-saas-platform",
    webapp: "",
    member: [
      {
        name: "Ronit Jena",
        img: "https://avatars.githubusercontent.com/u/98580165?s=400&u=bf85ede665674b964c8b3482ef3a67f03a247c68&v=4",
        linkedin: "https://www.linkedin.com/in/ronitjena/",
        github: "https://github.com/ronitjena09/",
      },
    ],
  },
  {
    id: 11,
    title: "VIBE - A MODERN MUSIC STREAMING EXPERIENCE",
    date: "December 2023-Present",
    description:
      "A full-stack music streaming application inspired by Spotify and Shazam, built using the latest web technologies such as Next.js (React), Chakra UI, Zustand, Howler.js for Frontend, and Node.js (Express.js), PostgreSQL, Passport.js for backend. Optimized and maintained the app by 80 percent.",
    image:
      "https://th.bing.com/th/id/R.c2a12cba057711495849088844f950cc?rik=982VbYW4HE09lQ&riu=http%3a%2f%2f1000logos.net%2fwp-content%2fuploads%2f2017%2f08%2fSpotify-Logo.png&ehk=Gcl8lyv0FdI4gDVyKLmVCVfNf8yc1xDmAvEDyPzt8Bk%3d&risl=&pid=ImgRaw&r=0",
    tags: [
      "Next.js",
      "Node.js ",
      "Tailwind CSS",
      ".NET",
      "Chakra UI",
      "Zustand",
      "Howler.js",
      "PostgreSQL",
      "Passport.js",
    ],
    category: "web app",
    github: "https://github.com/ronitjena09/ai-saas-platform",
    webapp: "",
    member: [
      {
        name: "Ronit Jena",
        img: "https://avatars.githubusercontent.com/u/98580165?s=400&u=bf85ede665674b964c8b3482ef3a67f03a247c68&v=4",
        linkedin: "https://www.linkedin.com/in/ronitjena/",
        github: "https://github.com/ronitjena09/",
      },
    ],
  },
];

export const TimeLineData = [
  { year: 2021, text: "Started my journey" },
  { year: 2022, text: "Worked as a Web Developer" },
  { year: 2023, text: "Learned Enumerate Skills" },
  { year: 2023, text: "Shared my projects with the world" },
];
